import { render } from "./WeMakeYourNoneCore.vue?vue&type=template&id=8aef55b2"
import script from "./WeMakeYourNoneCore.vue?vue&type=script&lang=js"
export * from "./WeMakeYourNoneCore.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__